import { combineReducers } from 'redux';

import coordinates from './reducers/coordinates';
import savedSearches from './reducers/saved_searches';
import search from './reducers/search';
import session from './reducers/session';
import selectList from './reducers/select_list';
import query from './reducers/query';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  coordinates,
  customFieldSchemas: customFieldSchemas => customFieldSchemas || [],
  dromoImporterProps: nullReducer,
  features: nullReducer,
  paths: nullReducer,
  query,
  scope: nullReducer,
  savedSearches,
  search,
  session,
  selectList,
  static: nullReducer,
  ui
});
